module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Jenny Walker lives in Northallerton, the County Town of North Yorkshire. She has spent most of her life working in offices where, amongst other things, she achieved ISO:9001 and IIP, along with writing H&S manuals, company handbooks and HR documentation.")]), _vm._v(" "), _c('p', [_vm._v("In complete contrast, Jenny also spent several years as a poultry breeder. Jenny is now a full-time author.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("www.jennywalkerauthor.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0